import { useEffect, useState } from "react";
import { Link, Navigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refreshUser } = useAuth();
  const [state, setState] = useState("checking");
  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setState("error"); return; }
    let n = 0, stop = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { await refreshUser(); if (!stop) setState("ok"); return; }
      } catch { /* retry */ }
      if (++n < 15 && !stop) setTimeout(poll, 2000); else if (!stop) setState("pending");
    };
    poll();
    return () => { stop = true; };
  }, [params, refreshUser]);
  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 px-6" data-testid="payment-success-page">
      <div className="max-w-md text-center space-y-4">
        {state === "checking" && <><Loader2 className="h-10 w-10 animate-spin text-sky-600 mx-auto" /><p data-testid="payment-checking">Conferma dell'abbonamento in corso…</p></>}
        {state === "ok" && <><CheckCircle2 className="h-12 w-12 text-emerald-600 mx-auto" /><h1 className="font-display text-2xl font-bold" data-testid="payment-ok">Abbonamento attivato!</h1><p className="text-slate-600">La prova gratuita di 30 giorni è iniziata. Buon lavoro con Kreditofacile.</p><Link to="/" data-testid="payment-go-crm" className="inline-block rounded-full bg-[#0F172A] text-white px-6 py-3">Entra nel CRM</Link></>}
        {(state === "pending" || state === "error") && <><XCircle className="h-12 w-12 text-amber-500 mx-auto" /><p data-testid="payment-pending">Non riusciamo ancora a confermare il pagamento. Riprova tra qualche istante.</p><Link to="/abbonamento" className="text-sky-700 underline">Torna all'abbonamento</Link></>}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return <Navigate to="/abbonamento" replace />;
}
